import React, { useContext, useEffect, useState } from 'react'
import { Outlet } from 'react-router-dom'

import Navbarr from 'components/navbar/Navbar'
import { themeContext } from 'contexts/theme_context/ThemeContext'

export default function Master() {

  const { webtheme } = useContext(themeContext)
  const body = document.getElementsByTagName('body')[0].classList
  const main_theme = () => {
    if (webtheme == 'dark') {
      body.remove('light-main-bg')
      body.add('dark-main-bg')
    } else {
      body.remove('dark-main-bg')
      body.add('light-main-bg')
    }
  }

  useEffect(() => {
    main_theme()
  }, [])

  useEffect(() => {
    main_theme()
  }, [webtheme])

  return (
    <div className="h-100 col-12 p-0 me-0">
      <Navbarr />
      <div style={{ marginTop: "70px" }} className="content w-100">
        <Outlet />
      </div>
    </div>
  )
}
